/**
 * Decide whether a packet matches the given filter set.
 * Pure function reused on the FE to filter live socket packets the same way
 * the backend filters DB results.
 */
export function packetMatchesFilters(p, q) {
    if (q.deviceId && p.deviceId !== q.deviceId)
        return false;
    if (q.search && !p.deviceId.toLowerCase().includes(q.search.toLowerCase()))
        return false;
    if (q.eventType !== undefined && !p.events.some((e) => e.type === q.eventType))
        return false;
    if (q.pid !== undefined && p.pid !== q.pid)
        return false;
    if (q.tempCMin !== undefined && p.temperatureC < q.tempCMin)
        return false;
    if (q.tempCMax !== undefined && p.temperatureC > q.tempCMax)
        return false;
    if (q.humidityMin !== undefined && p.humidity < q.humidityMin)
        return false;
    if (q.humidityMax !== undefined && p.humidity > q.humidityMax)
        return false;
    if (q.batteryVMin !== undefined && p.batteryVoltageV < q.batteryVMin)
        return false;
    if (q.batteryVMax !== undefined && p.batteryVoltageV > q.batteryVMax)
        return false;
    if (q.eventCountMin !== undefined && p.eventCount < q.eventCountMin)
        return false;
    if (q.eventCountMax !== undefined && p.eventCount > q.eventCountMax)
        return false;
    return true;
}
//# sourceMappingURL=filters.js.map